import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Grid, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as HeinsohnWelcome } from 'assets/images/imagenLogin.svg';
import { ReactComponent as HeinsohnLogo } from 'assets/images/logoHeinsohnBlanco.svg';
import { withNotification } from 'wrappers';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import Cookie from 'js-cookie';
import {
 Loader, TextOtpBase, ButtonBase, BaseModal, BaseModalError,
} from 'components';
import {
    masterMessages, abreviaturas, messages, masterEvents,
} from 'constantes';
import { LoginBusiness } from 'business/business/LoginBusiness';
import { validatePermissionDoc } from 'utils/Functions';
import { termsAndConditionsBase64pdf } from 'assets/docs/termsConditionsPDF';
import { AnalyticsAmplitud } from 'utils/Analytics-Amplitud';
import authService from 'auth/AuthService';

// Segundos del timer
const DEFAULT_SECONDS = 60;

// Estilos de la pagina
const useStyles = makeStyles((theme) => ({
    companyImage: {
        background: 'linear-gradient(90deg, #E02A58, #C00333)',
        borderTopLeftRadius: '1.20rem',
        borderBottomLeftRadius: '1.20rem',
        boxShadow: '0rem 0.188rem 0.375px #9CBEDB29',
        paddingTop: '6.99rem',
        textAlign: 'center',
        width: '95%',
        height: 'calc(100vh - 50px)',
    },
    headerImage: {
        width: '100%',
        marginTop: '-4.7rem',
        marginBottom: '0rem',
    },
    welcomeLogo: {
        width: '70%',
        height: 'calc(100vh - 180px)',
    },
    formCompany: {
        backgroundColor: '#FFFFFF',
        borderRadius: '0.625rem',
        boxShadow: '0px 12px 20px #53546A',
        padding: '20px 50px 30px 50px',
        marginTop: 60,
        textAlign: 'center',
        [theme.breakpoints.up('xs')]: {
            marginTop: '15%',
            width: '80%',
            height: 'auto',
            margin: '10% auto',
        },
        [theme.breakpoints.up('md')]: {
            marginTop: '10%',
            width: '95%',
            height: 'auto',
            margin: '10% auto',
        },
        [theme.breakpoints.up('lg')]: {
            marginTop: '10%',
            width: '95%',
            height: '10% auto',
        },
        [theme.breakpoints.up('xl')]: {
            marginTop: '20%',
            marginBottom: '20%',
            width: '80%',
            height: 'auto',
            margin: '10% auto',
        },
    },
    containerLogin: {
        position: 'absolute',
        height: 'calc(100vh - 40px)',
        overflow: 'hidden',
        [theme.breakpoints.up('xs')]: {
            overflow: 'inherit',
        },
    },
    login: {
        textAlign: 'center',
        margin: '0 auto',
        [theme.breakpoints.up('xs')]: {
            marginTop: '0',
            width: '100%',
        },
        [theme.breakpoints.up('md')]: {
            marginTop: '12%',
            width: '70%',
        },
        [theme.breakpoints.up('lg')]: {
            marginTop: '12%',
            width: '70%',
        },
        [theme.breakpoints.up('xl')]: {
            marginTop: '12%',
            width: '90%',
        },
    },
    welcome: {
        fontSize: '2.4rem',
        fontWeight: 'bold',
        color: '#3E3E3C',
        lineHeight: '100%',
    },
    lineH: {
        width: 33,
        height: 2,
        background: 'linear-gradient(90deg, #E02A58, #C00333)',
        opacity: 1,
        margin: 'auto',
        marginTop: 11,
    },
    saludo: {
        fontSize: 20,
        color: '#3E3E3C',
        fontWeight: 'bold',
        marginTop: 20,
    },
    message: {
        fontSize: 13,
        fontWeight: 'normal',
        color: '#3E3E3C',
        marginTop: 20,
    },
    timerCode: {
        fontSize: 13,
        fontWeight: 'normal',
        // color: '#53546A',
        color: '#3E3E3C',
        marginTop: 20,
        marginBottom: -10,
    },
    reSendCode: {
        fontSize: 13,
        fontWeight: 'bold',
        color: '#C00333',
        marginTop: 20,
        marginBottom: -5,
        cursor: 'pointer',
    },
    frameContainer: {
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        paddingTop: '40.25%',
    },
    responsiveIframe: {
        position: 'absolute',
        top: '0',
        left: '0',
        bottom: '0',
        right: '0',
        width: '100%',
        height: '100%',
    },
}));

/**
 * @desc Objeto que evalua si los campos del formulario son correctos
 */
const validationSchema = Yup.object({
    otpNumber: Yup.string().required('El código es requerido'),
});

// Array para almacenar OTP
const otpArray = new Array(6);

function ValidationOtp({
                           history, match, appSuccess, appError,
                       }) {
    const politicaVersion = abreviaturas.DEFAULT_POLITICAS.version;
    const { params: { solicitudId } } = match;
    // Mensajes a mostrar
    const {
        auth: { codeOtp: formMessages, tratamientoDatos },
        pdfViewer: { modalDocProceso },
        buttons,
    } = masterMessages;
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [openModalError, setOpenModalError] = useState(false);
    const [termVersion, setTermsVersion] = useState(politicaVersion);
    const [polVersion, setPolVersion] = useState(false);
    const [resendCode, setResendCode] = useState(false);
    const [secs, setSeconds] = useState(DEFAULT_SECONDS);
    const [otpValue, setOtpValue] = useState(null);
    const [termsPDF, setTermsPDF] = useState(termsAndConditionsBase64pdf);
    const values = {
        otpNumber: '',
    };
    const { otpNumber } = values || {};

    /**
     * @desc inicializador de contador para enviar codigo OTP a API
     */
    useEffect(() => {
        const secondsInterval = setInterval(() => {
            if (secs > 0) {
                setSeconds(secs - 1);
            }
            if (secs === 0) {
                setResendCode(true);
            }
        }, 1000);
        return () => {
            clearInterval(secondsInterval);
        };
    });

    // Eeventos para abrir y cerrar Modal
    const handleCloseModal = () => {
        setOpenModal(false);
        setOpenModalError(false);
    };

    /**
     * @name handleOpenModal
     * @desc Abre la modal de politicas y captura el codigo OTP ingresado
     * @param formValues
     * @returns {Promise<void>}
     */
    const handleOpenModal = async (formValues = {}) => {
        // Se valida el codigo OTP y luego se abre la modal de politicas
        setLoading(true);
        const { otpNumber: code } = formValues || ''; // Destructuracion para sacar el codigo
        // Guardo OTP globalmente
        Cookie.set(abreviaturas.DEFAULT_OTP_NUMBER, code);

        try {
            // Se envia codigo al api para validar
            const res = await LoginBusiness.validateEmailOTPCode({ codigo: code || '' });
            if (res.status === abreviaturas.DEFAULT_HTTP_OK[1]) {
                // Conexión con analiticas al enviar OTP
                AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_OTP);
                setOpenModal(true);
            } else {
                appError(messages.errors.codeNoValid);
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            appError(messages.errors.submitting);
        }
    };

    /**
     * @name getPoliticaVersion
     * @desc Consulta la version de los terminos y condiciones con el fin
     * de crear un flujo respecto a la modal para actualizar esta politica
     * @returns {Promise<void>}
     */
    const getPoliticaVersion = async () => {
        try {
            let versionInit = null;
            let versionFinal = null;
            // Se envia solicitud al api para validar la version de los terminos
            await LoginBusiness.getVersionTermsAndConditions().then((res) => {
                if (res.status === abreviaturas.DEFAULT_HTTP_FAIL[0]
                    || res.status === abreviaturas.DEFAULT_HTTP_FAIL[1]) {
                    versionInit = politicaVersion;
                    setPolVersion(versionInit !== politicaVersion);
                }
                if (res.status === abreviaturas.DEFAULT_HTTP_OK[0]
                    || res.status === abreviaturas.DEFAULT_HTTP_OK[1]) {
                    versionInit = res.json();
                    versionInit.then((resp) => {
                        versionFinal = (resp === politicaVersion)
                            ? politicaVersion : resp;
                        setTermsVersion(versionFinal || null); // si existe la version se guarda
                        setPolVersion(versionFinal === politicaVersion);
                    });
                }
            });
        } catch (e) {
            setLoading(false);
        }
    };

    /**
     * @name getTermsPDF
     * @desc Consulta el PDF de los terminos y condiciones con el fin
     * de crear un flujo respecto a la modal para actualizar esta politica
     * @returns {Promise<void>}
     */
    const getTermsPDF = async () => {
        try {
            // Se envia solicitud al api para consultar el documento
            await LoginBusiness.getTermsAndConditionsPDF().then(async (res) => {
                if (res.status === abreviaturas.DEFAULT_HTTP_OK[0]
                    || res.status === abreviaturas.DEFAULT_HTTP_OK[1]) {
                    const resp = await res.json();
                    if (resp && resp.base64) {
                        setTermsPDF(`${abreviaturas.DEFAULT_TYPE_CONTENT_B64}${resp.base64}`);
                    } else {
                        setTermsPDF(termsAndConditionsBase64pdf);
                    }
                }
            });
        } catch (e) {
            setLoading(false);
        }
    };

    /**
     * @name onSendCodeOTP
     * @desc Funcion para solicitar un codigo de verificacion al api
     * @returns {Promise<void>}
     */
    const onSendCodeOTP = async () => {
        try {
            // Se envia solicitud al api del codigo
            await LoginBusiness.sendEmailOTPCode();
            if (resendCode) {
                setResendCode(false);
                setSeconds(DEFAULT_SECONDS);
            }
            appSuccess(messages.dataFetch.sendCode);
        } catch (e) {
            setLoading(false);
            appError(messages.errors.submitting);
        }
    };

    // se inicializa componente enviando codigo y validando version terminos
    useEffect(() => {
        let validation = false;
        // Consulto permisos sobre el doc
        const fetchPermissionsDoc = async () => {
            try {
                await validatePermissionDoc(solicitudId).then((res) => {
                    validation = res;
                    setOpenModalError(validation);

                    if (!validation) {
                        const fetchTermsPDF = async () => {
                            await getTermsPDF().then((resp) => resp);
                        };
                        const fetchTermsVersion = async () => {
                            await getPoliticaVersion().then((resp) => resp);
                        };

                        fetchTermsPDF().then((respP) => respP);
                        fetchTermsVersion().then((respV) => respV);
                        onSendCodeOTP().then((resCo) => resCo);
                    }
                    setLoading(false);
                });
            } catch (e) {
                appError(messages.dataFetch.fail);
                authService.logout();
                history.push('/apiv1/sign-in');
            }
        };

        fetchPermissionsDoc().then((res) => res);
    }, []);

    /**
     * @name saveVersionTerms
     * @desc Metodo que guarda la version de politica actualizada
     * @param check
     * @returns {Promise<void>}
     */
    const saveVersionTerms = async () => {
        try {
            // Se envia solicitud al api para guardar version de terminos y condiciones
            const res = await LoginBusiness.saveTermsAndConditions(termVersion);

            if (res.status === abreviaturas.DEFAULT_HTTP_OK[1]) {
                setLoading(false);
                appSuccess(messages.dataFetch.success);
                history.replace(`/apiv1/pdf-viewer/${solicitudId}`);
            } else {
                appError(messages.errors.invalidFormat);
            }
            setOpenModal(false);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            appError(messages.errors.submitting);
        }
    };

    /**
     * @name onSubmit
     * @desc Funcion que envia el codigo ingresado al api para verificacion
     * @returns {Promise<void>}
     */
    const onSubmit = async () => {
        const code = otpValue;
        // Guardo OTP globalmente
        Cookie.set('otpNumber', code);

        try {
            // Se envia codigo al api para validar
            const res = await LoginBusiness.validateEmailOTPCode({ codigo: code || '' });
            if (res.status === abreviaturas.DEFAULT_HTTP_OK[1]) {
                AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_OTP);
                history.replace(`/apiv1/pdf-viewer/${solicitudId}`);
            } else {
                appError(messages.errors.codeNoValid);
            }
            setOpenModal(false);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            appError(messages.errors.submitting);
        }
    };

    /**
     * @name changeArrayOtp
     * @desc Función para almacenar el valor del OTP en un array
     * @param otpObj
     */
    const changeArrayOtp = (otpObj) => {
        const { index, code } = otpObj || {};
        otpArray[index] = code;

        // Se setea el valor al formulario
        setOtpValue(otpArray.join(' '));
    };

    return loading ? <Loader /> : (
      <>
        {Boolean(!openModalError) && (
          <div className="containerWrapper">
            <div className={classes.containerLogin}>
              <Grid container spacing={2}>
                <Hidden only={['xs']}>
                  <Grid item sm={6} md={6} xl={6}>
                    <Container className={classes.companyImage}>
                      <HeinsohnLogo className={classes.headerImage} />
                      <HeinsohnWelcome className={classes.welcomeLogo} />
                    </Container>
                  </Grid>
                </Hidden>
                <Grid item xs={12} sm={6} md={6} xl={6}>
                  <Container className={classes.formCompany}>
                    <div className={classes.login}>
                      <h1 className={classes.welcome}>{formMessages.title}</h1>
                    </div>
                    <hr className={classes.lineH} align="left" />
                    <p className={classes.saludo}>{formMessages.subtitle}</p>
                    <p className={classes.message}>{formMessages.message}</p>

                    <Formik
                      enableReinitialize
                      initialValues={{
                                      otpNumber,
                                  }}
                      validationSchema={validationSchema}
                      onSubmit={polVersion ? onSubmit : handleOpenModal}
                    >
                      {(subProps) => (
                        <Form>
                          <Grid container alignItems="center" justifyContent="center" spacing={2}>
                            <Grid item xs={8} md={8}>
                              <Field name="otpNumber" component={TextOtpBase} onChangeArray={(event) => changeArrayOtp(event)} />
                            </Grid>
                            <Grid container alignItems="center" justifyContent="center" style={{ marginBottom: 15 }}>
                              <Grid item xs={6} md={6}>
                                {Boolean(!resendCode) && (
                                  <>
                                    <p className={classes.timerCode}>
                                      Tu código vence en
                                      {' '}
                                      00:
                                      {secs}
                                    </p>
                                    <ButtonBase
                                      disabled={subProps.isSubmitting}
                                      caption={buttons.verify}
                                      colorBase={abreviaturas.DEFAULT_RED_COLOR}
                                    />
                                  </>
                                  )}
                                {Boolean(resendCode) && (
                                    // eslint-disable-next-line max-len
                                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                                  <div
                                    className={classes.reSendCode}
                                    onClick={() => onSendCodeOTP()}
                                  >
                                    <span>
                                      Reenviar código
                                    </span>
                                  </div>
                                  )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Form>
                                  )}
                    </Formik>
                  </Container>
                </Grid>
              </Grid>
            </div>
          </div>
          )}

        {/* Modal de politicas */}
        {Boolean(openModal) && (
          <BaseModal
            open
            onClose={handleCloseModal}
            title={tratamientoDatos.title}
            message={tratamientoDatos.message}
            maxWidth="xl"
            close={false}
          >
            <Grid container>
              <Grid item xs={12} md={12}>
                <div className={classes.frameContainer}>
                  <iframe title="TerminosCondiciones" src={`${termsPDF}#toolbar=0&navpanes=0`} className={classes.responsiveIframe} />
                </div>
                <Grid container alignItems="center" justifyContent="center" style={{ marginBottom: 15 }}>
                  <Grid item xs={6} md={6}>
                    <ButtonBase
                      caption={buttons.aceptPol}
                      colorBase={abreviaturas.DEFAULT_RED_COLOR}
                      onClickEvent={saveVersionTerms}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </BaseModal>
          )}

        {/* Modal de Error sin permisos */}
        {Boolean(openModalError) && (
          <BaseModalError
            handleCloseModal={handleCloseModal}
            maxWidth="sm"
            messages={modalDocProceso}
          />
          )}
      </>
    );
}

ValidationOtp.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            solicitudId: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
        }).isRequired,
    }).isRequired,
    appSuccess: PropTypes.func.isRequired,
    appError: PropTypes.func.isRequired,
};

export default withNotification(ValidationOtp);
